import { render } from "./TheRooms.vue?vue&type=template&id=13fb77aa"
import script from "./TheRooms.vue?vue&type=script&lang=js"
export * from "./TheRooms.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__